import React from "react";

import { ValanzLoader } from "./ValanzLoader";

export const ValanzLoaderComponent: React.FC = () => {
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "90vh",
			}}
		>
			<ValanzLoader />
		</div>
	);
};
